.root {
    min-width: 0;
    overflow: hidden;
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
}

.multiline {
    max-height: 52px;
    flex-wrap: wrap;
    align-content: flex-start;
    align-items: center;
    white-space: normal;
}

.remaining {
    --label-color: rgb(7, 141, 97);

    height: 19px;
    min-width: 0;
    max-width: none;
    display: inline-flex;
    align-items: center;
    flex: 0 1 auto;
    padding: 0 8px;
    border-radius: 8px;
    background-color: color-mix(in srgb, var(--label-color) 12%, white);
    color: var(--label-color);
}

.remainingBody {
    height: 24px;
    padding: 0 8px;
}

.text {
    min-width: 0;
    overflow: hidden;
    color: inherit;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
}
